import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpService } from '../services/http.service';

@Injectable({
    providedIn: 'root'
})
export class MitraGuard implements CanActivate {
    public static cachedToken: string | null = null;
    public static cachedUserId: string | null = null;

    constructor(
        private http: HttpService,
        private router: Router
    ) { }

    public static clearCache(): void {
        MitraGuard.cachedToken = null;
        MitraGuard.cachedUserId = null;
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const paramId = route.params['id'];
        const token = localStorage.getItem('token');

        if (!token) {
            MitraGuard.clearCache();
            return of(
                this.router.createUrlTree(['/login'], {
                    queryParams: { username: paramId }
                })
            );
        }

        // Fast-path: return cached validation if token matches and cached user is known
        if (token === MitraGuard.cachedToken && MitraGuard.cachedUserId) {
            return of(
                String(paramId) === String(MitraGuard.cachedUserId)
                    ? true
                    : this.router.createUrlTree(['/mitra', MitraGuard.cachedUserId])
            );
        }

        return this.http
            .get('/api/v1/wp/mitra/auth/get-user-id')
            .pipe(
                tap((res: any) => {
                    const userId = res?.data?.user_id;
                    if (userId) {
                        MitraGuard.cachedToken = token;
                        MitraGuard.cachedUserId = String(userId);
                    }
                }),
                map((res: any) => {
                    const userId = res?.data?.user_id;

                    if (!userId) {
                        MitraGuard.clearCache();
                        return this.router.createUrlTree(['/login'], {
                            queryParams: { username: paramId }
                        });
                    }

                    return String(paramId) === String(userId)
                        ? true
                        : this.router.createUrlTree(['/mitra', userId]);
                }),
                catchError((err: any) => {
                    MitraGuard.clearCache();
                    if (err?.status === 403) {
                        if (typeof localStorage !== 'undefined') {
                            localStorage.setItem('mitra_is_inactive', 'true');
                        }
                        const message = err?.error?.responseDesc || err?.error?.responseMessage || err?.error?.detail?.responseMessage || 'Akun Anda saat ini tidak aktif atau belum disetujui. Silakan hubungi admin / sales.';
                        return of(this.router.createUrlTree(['/access'], {
                            queryParams: {
                                reason: 'forbidden',
                                from: this.router.url,
                                message
                            }
                        }));
                    }
                    return of(this.router.createUrlTree(['/login']));
                })
            );
    }
}
